import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { useHistory } from '@atlassian/mpac-ui';
import { DynamicTableUtils } from '@atlassian/mpac-utils';
import isEqual from 'lodash/isEqual';
import * as queryString from 'query-string';
import React from 'react';
import { REPORTS_ROWS_PER_PAGE } from '../../../constants/Preferences';
import ErrorMessage from '../Common/ErrorMessage';
import TableTreeWrapper from '../Common/TableTreeWrapper';
import { tableDataAnalyticsConfig } from '../PartnerReports.events';
import { getNewReportPathname, getNewSearch } from '../ReportsFilters/ReportFilters.utils';
import { mapQueryParamsToApiParams } from './FeedbackDetails.utils';
import { FeedbackDetailsHeader, getFeedbackDetailsBody } from './FeedbackDetailsTableData';
import { useFeedbackDetails } from './hooks';
const FeedbackDetails = props => {
  const history = useHistory();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    enableSenDeprecationChanges
  } = useFeatureFlags();
  const {
    feedbackDetailsAPIResponse,
    pending,
    error
  } = useFeedbackDetails(props.mpacBaseUrl, props.partnerId, mapQueryParamsToApiParams(props.queryParams), String(REPORTS_ROWS_PER_PAGE));
  const count = feedbackDetailsAPIResponse === null || feedbackDetailsAPIResponse === void 0 ? void 0 : feedbackDetailsAPIResponse.totalCount;
  const offset = props.queryParams.offset || 0;
  const rowsPerPage = DynamicTableUtils.getRowsPerPage(count, REPORTS_ROWS_PER_PAGE);

  // eg: If offset is 10, page number would be 2 (10/10 + 1)
  const pageNum = Number.parseInt(offset.toString(), 10) / rowsPerPage + 1;
  const updateQueryParams = (queryParam, value) => {
    if (history) {
      const queryParams = queryString.parse(history.location.search || '');
      history.push({
        pathname: getNewReportPathname(props.partnerId, props.reportName, false, ''),
        search: getNewSearch(queryParams, queryParam, value)
      });
    }
  };
  const getReportsLink = (queryParam, value, columnName) => {
    const reportName = columnName === 'licenseId' ? 'licenses' : props.reportName;
    const pathname = getNewReportPathname(props.partnerId, reportName, false, '');
    const search = getNewSearch({}, queryParam, value);
    return pathname + search;
  };
  const fireEvent = (queryParam, value) => {
    fireAnalyticsEvent(tableDataAnalyticsConfig({
      partnerId: props.partnerId,
      reportName: props.reportName,
      queryParam,
      value: value === undefined ? '' : value
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(ErrorMessage, {
    error: error.error,
    status: error.status
  }), !error && /*#__PURE__*/React.createElement(TableTreeWrapper, {
    head: FeedbackDetailsHeader(enableSenDeprecationChanges),
    items: getFeedbackDetailsBody((feedbackDetailsAPIResponse === null || feedbackDetailsAPIResponse === void 0 ? void 0 : feedbackDetailsAPIResponse.feedback) || [], getReportsLink, fireEvent, enableSenDeprecationChanges),
    isLoading: pending,
    rowsPerPage: rowsPerPage,
    page: pageNum,
    onSetPage: page => updateQueryParams('offset', ((page - 1) * REPORTS_ROWS_PER_PAGE).toString()),
    totalRows: count !== null && count !== void 0 ? count : 0,
    testId: "feedback-details-success"
  }));
};
export default /*#__PURE__*/React.memo(FeedbackDetails, isEqual);